{
  "ResultFields": {
    "role": "Rola",
    "button": "Pola wyników",
    "title": "Pola wyników",
    "onlyMe": "Tylko dla mnie",
    "line": "Druga linia",
    "lineLimit": "do {{max}}",
    "lineEmpty": "Nic pod nazwą.",
    "order": "Kolejność drugiej linii",
    "noCatalog": "Brak pól do pokazania.",
    "right": "Po prawej",
    "rightHint": "Zdjęcia są zawsze ostatnie.",
    "pictures": "Zdjęcia",
    "reset": "Przywróć domyślne"
  },
  "ResourceFieldSections": {
    "label": "Pola zasobów",
    "groups": {
      "profile": "Profil",
      "contact": "Kontakt",
      "social": "Social media",
      "custom": "Pola własne"
    }
  }
}
